"use client";

import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useNotifications } from "@/app/hooks/useNotifications";
import NotificationDrawer from "@/app/components/notifications/NotificationDrawer";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { emailId, unreadCount, refresh, ...hookRest } = useNotifications();
  const hook = { emailId, unreadCount, refresh, ...hookRest };

  useEffect(() => {
    if (open) {
      void refresh({ syncReminders: true });
    }
  }, [open, refresh]);

  if (!emailId) {
    return null;
  }

  return (
    <>
      <button
        id="notification-bell-btn"
        type="button"
        className="k-main-header__icon-btn k-main-header__icon-btn--notifications flex text-color-gray hover:text-color-primary"
        onClick={() => setOpen(true)}
        aria-label={`Notifications${hook.unreadCount > 0 ? `, ${hook.unreadCount} unread` : ""}`}
      >
        <Bell size={22} strokeWidth={1.75} aria-hidden="true" />
        {hook.unreadCount > 0 && (
          <span
            id="notification-badge"
            className="k-main-header__notification-badge"
          >
            {hook.unreadCount > 99 ? "99+" : hook.unreadCount}
          </span>
        )}
      </button>

      <NotificationDrawer
        open={open}
        onClose={() => setOpen(false)}
        hook={hook}
      />
    </>
  );
}
